module.exports = __webpack_public_path__ + "img/themes.0bb21a51.svg";